// @ts-nocheck
/** @param {{ checked: boolean, onChange: (next: boolean) => void, label: string }} props */
export default function Toggle({ checked, onChange, label }) {
  return (
    <label className="inline-flex items-center gap-2 text-sm text-slate-700">
      <button
        type="button"
        role="switch"
        aria-checked={checked}
        className={`relative h-5 w-9 rounded-full ${checked ? 'bg-[#0F766E]' : 'bg-slate-300'}`}
        onClick={() => onChange(!checked)}
      >
        <span className={`absolute top-0.5 h-4 w-4 rounded-full bg-white transition-all ${checked ? 'left-4' : 'left-0.5'}`} />
      </button>
      {label}
    </label>
  );
}
